var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38779 15.0586C1.56279 15.0586 0.812793 14.2336 0.812793 13.4086L0.737793 3.05859C0.737793 2.23359 1.41279 1.55859 2.23779 1.55859H3.73779V0.0585938H5.23779V1.55859H11.3128V0.0585938H12.8128V1.55859C15.5878 1.55859 15.8128 2.00859 15.8128 3.58359V13.4086C15.8128 14.3086 15.2128 15.0586 14.3878 15.0586H2.38779ZM13.4878 13.5586C13.8628 13.5586 14.2378 13.2586 14.2378 12.8086V7.55859H2.23779V12.8086C2.23779 13.2586 2.53779 13.5586 2.98779 13.5586H13.4878ZM2.23779 6.05859H14.2378V3.80859C14.2378 3.35859 13.9378 3.05859 13.4878 3.05859H12.7378V4.55859H11.2378V3.05859H5.23779V4.55859H3.73779V3.05859H2.98779C2.53779 3.05859 2.23779 3.43359 2.23779 3.80859V6.05859ZM10.7973 11.7917C11.5747 11.7917 12.2049 11.1615 12.2049 10.3842C12.2049 9.60679 11.5747 8.97661 10.7973 8.97661C10.02 8.97661 9.38979 9.60679 9.38979 10.3842C9.38979 11.1615 10.02 11.7917 10.7973 11.7917Z",
    fill: "white",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarIcon.3894cddc.svg";
export { ForwardRef as ReactComponent };